/* eslint-disable react/no-unused-state */
/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import Header from './Header';
import { CarbonCard, CarbonCardSecondary, CarbonCardText, S } from './styles';
import TransportData from './TransportData';
import TrackingFooter from './TrackingFooter';
import TrackingManager from './TrackingManager';
import ConfirmationModal from './ConfirmationModal';
import RegisterModal from '../../../../RecipientTracking/RegisterModal';
import StatusFlow from './StatusFlow';

import { BreakpointValues } from '../../../../../constants';

// (12-2025-Tracking-Cors)
// import {
//   apiKey,
//   baseURL,
//   // eslint-disable-next-line camelcase
//   tracking_manager,
// } from '../../../../../constants/Endpoints';

import { rolesList } from '../../../../../redux/auth';
import {
  _updateCustomerUser,
  _createCustomerUser,
  createCustomerUser,
  _createCustomerUserSuccess,
} from '../../../../../redux/tracking-manager';
import { showToastError } from '../../../../../components/toasty';
import NoTracking from './NoTracking';
import Co2Icon from '../../../../../images/co2-icon.png';
import Co2IconSecondary from '../../../../../images/co2-icon2.png';
import { isHealthCareDivision, isAgroDivision } from '../../../../../utils/division';

const _hasRole = (role, userRoles) => userRoles.indexOf(role) !== -1;

class NewTrackingNFItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 512,
      trackingManagerActive: false,
      showConfirmationModal: false,
      isFetchingTracker: true,
      disabledTracking: false,
      showRegisterModal: false,
      isNoTracking: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    const { nfData } = this.props;

    // (12-2025-Tracking-Cors)
    //this._handleCheckTracking(nfData.cnpjDest);

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
  }

  // (12-2025-Tracking-Cors)
  /*componentDidUpdate(prevProps) {
    const { nfData } = this.props;
    if (prevProps.nfData !== nfData) {
      this._handleCheckTracking(nfData.cnpjDest);
    }
  }*/

  componentWillUnmount() {
    window.removeEventListener(
      'resize',
      this.updateWindowDimensions.bind(this),
    );
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  _handleShowRegisterModal = async data => {
    const { name, email, phone, company, trackingActive } = data;
    const { dispatch } = this.props;

    if ((name, email, phone, company)) {
      await dispatch(
        createCustomerUser(
          {
            name,
            email,
            phone,
            trackingActive,
            taxNumber: company.cd_CGCCPF,
          },
          () => {
            this.setState({ showRegisterModal: !this.state.showRegisterModal });
          },
        ),
      );
    }
  };

  _handleCloseShowRegisterModal = () => {
    const { dispatch } = this.props;
    dispatch(_createCustomerUserSuccess());

    this.setState({ showRegisterModal: false });
  };

  // (12-2025-Tracking-Cors)
   // _handleTrackingManager = async cnpj => {
  //   const { dispatch, onConfirmClick, reloadPage } = this.props;

  //   dispatch(_updateCustomerUser());

  //   const id =
  //     window.localStorage.getItem('Luft/CustomerService/CompanyId') ||
  //     window.localStorage.getItem('Luft/CompanyId');

  //   if (!id) {
  //     return showToastError(
  //       <>
  //         <span>
  //           Ops. Parece que alguma coisa deu errado. Se o erro persistir, por
  //           favor, entre em contato com nosso suporte:
  //         </span>
  //         <br />
  //         <span>(11) 4772-4200</span>
  //         <br />
  //         <span>
  //           <a style={{ color: '#fff' }} href="mailto:luft@contato.com.br">
  //             luft@contato.com.br
  //           </a>
  //         </span>
  //       </>,
  //     );
  //   }

  //   const url = `${baseURL}${tracking_manager.UPDATE_CUSTOMER_TRACKING}`;

  //   try {
  //     await axios.post(
  //       url,
  //       {
  //         companyId: id,
  //         taxNumber: cnpj,
  //         hasTracking: !this.state.trackingManagerActive,
  //       },
  //       {
  //         headers: {
  //           'api-td-key': apiKey,
  //         },
  //       },
  //     );

  //     this.setState({
  //       trackingManagerActive: !this.state.trackingManagerActive,
  //     });
  //   } catch (error) {
  //     console.log(error);
  //     if (error.response) {
  //       if (error.response.status === 400) {
  //         onConfirmClick();
  //       }
  //     }
  //   } finally {
  //     reloadPage();
  //   }
  // };

  // _handleCheckTracking = async taxNumber => {
  //   const id =
  //     window.localStorage.getItem('Luft/CustomerService/CompanyId') ||
  //     window.localStorage.getItem('Luft/CompanyId');

  //   const url = `${baseURL}${tracking_manager.UPDATE_CUSTOMER_TRACKING}${id}`;

  //   try {
  //     const response = await axios.post(
  //       url,
  //       {
  //         customers: [taxNumber],
  //       },
  //       {
  //         headers: {
  //           'api-td-key': apiKey,
  //         },
  //       },
  //     );

  //     this.setState({
  //       trackingManagerActive: response.data[0].HasTracking > 0 ? true : false,
  //       isFetchingTracker: false,
  //       isNoTracking: false,
  //     });
  //   } catch (error) {
  //     if (error.response) {
  //       if (error.response.status === 400) {
  //         this.setState({
  //           trackingManagerActive: false,
  //           isFetchingTracker: false,
  //           isNoTracking: true,
  //         });
  //       } else if (error.response.status === 403) {
  //         this.setState({
  //           trackingManagerActive: false,
  //           isFetchingTracker: false,
  //           isNoTracking: false,
  //         });
  //       } else {
  //         console.log(error);
  //         this.setState({
  //           disabledTracking: true,
  //         });
  //       }
  //     } else {
  //       console.log(error);
  //       this.setState({
  //         disabledTracking: true,
  //       });
  //     }
  //   }
  // };

  // _handleShowConfirmationModal = () => {
  //   this.setState({ showConfirmationModal: !this.state.showConfirmationModal });
  // };


  // _renderTrackingManager = () => {
  //   const { roles } = this.props;
  //   const {
  //     isFetchingTracker,
  //     isNoTracking,
  //     disabledTracking,
  //     trackingManagerActive,
  //     width,
  //   } = this.state;

  //   const isMobile = width < BreakpointValues.sm;

  //   const isAdmin = _hasRole(rolesList.ADMINISTRATOR, roles);
  //   const isRecipientTracking = _hasRole(rolesList.RECIPIENT_TRACKING, roles);

  //   const isCCABUser =
  //     (window.localStorage.getItem('Luft/CustomerService/CompanyName') ||
  //       window.localStorage.getItem('Luft/CompanyName')) === 'CCAB';
  //   const isGOPLANUser =
  //     window.localStorage.getItem('Luft/UserEmail') ===
  //     'gustavo.gambera@goplan.com.br';

  //   if (!isCCABUser && !isGOPLANUser) {
  //     return;
  //   }

  //   if ((isAdmin || isRecipientTracking) && !disabledTracking) {
  //     return (
  //       <S.TrackingContainer isMobile={isMobile}>
  //         {!isFetchingTracker ? (
  //           !isNoTracking ? (
  //             <TrackingManager
  //               label="Rastreio para o destinatário"
  //               checked={trackingManagerActive}
  //               onChange={this._handleShowConfirmationModal}
  //             />
  //           ) : (
  //             <NoTracking label="Rastreio para destinatário indisponível" />
  //           )
  //         ) : (
  //           <S.NoTracking />
  //         )}
  //       </S.TrackingContainer>
  //     );
  //   }
  // };

  render() {
    const {
      nfData,
      onClick,
      openOccurence,
      openReceipt,
      hasPosition,
      customerCompaniesList,
      currentCompanyDivisions = [],
      roles,
    } = this.props;
    const {
      nf,
      cte,
      order, // número do pedido
      cnpjDest,
      performance,
      orderCustumer,
      orderCustumerDate,
      orderCustomerName,
      orderDate, // Data de solicitação
      nfDate, // Usar para status faturamento (FRONT)
      origin,
      reDelivery,
      hasOccurence,
      shippingCompany,
      destination,
      wms,
      tms,
      isNfAg,
      stepInvoice,
      carbonEmission,
      predictedCarbonEmission,
      carbonCredit,
    } = nfData;

    const { width } = this.state;

    const isDesktop = width > BreakpointValues.md;
    const isTablet = width > BreakpointValues.sm && width < BreakpointValues.md;
    const isMobile = width < BreakpointValues.sm;

    const deliveryMade = carbonCredit > 0;
    const deliveryNotMade = predictedCarbonEmission > 0 && !carbonCredit && !carbonEmission;
    const isAgro = isAgroDivision(currentCompanyDivisions);
    const isHealthCare = isHealthCareDivision(currentCompanyDivisions);
    const showCarbonCard = deliveryMade && isHealthCare;

    return (
      <div onClick={onClick}>
        {showCarbonCard ? (
          <CarbonCard>
            <img src={Co2Icon} width={34} height={34} alt="CO2" />
            <CarbonCardText>
              Esta nota gerou<strong>&nbsp;* RCE&nbsp;</strong> a compensar
            </CarbonCardText>
          </CarbonCard>
        ) : null} 
        
        {deliveryNotMade ? (
          <CarbonCardSecondary>
            <img src={Co2IconSecondary} width={34} height={34} alt="CO2" />
            <CarbonCardText>
              Emissão de carbono prevista de
              <strong>&nbsp;{predictedCarbonEmission} T. CO2 EQ.</strong>
            </CarbonCardText>
          </CarbonCardSecondary>
        ) : null}
        <S.TrackingItemContainer>
          <S.HeaderWrapper>
            <Header
              order={order}
              nf={nf}
              cte={cte}
              performance={performance}
              orderCustumer={orderCustumer}
              orderCustumerDate={orderCustumerDate}
              orderCustomerName={orderCustomerName}
              orderDate={orderDate}
              nfDate={nfDate}
              wms={wms}
              tms={tms}
              isNfAg={isNfAg}
              isMobile={isMobile}
              isTablet={isTablet}
              isDesktop={isDesktop}
              // eslint-disable-next-line consistent-return
              transportData={() => {
                if (isMobile) {
                  return (
                    <>
                      <TransportData
                        origin={origin}
                        reDelivery={reDelivery}
                        destination={destination}
                        shippingCompany={shippingCompany}
                        isMobile={isMobile}
                      />
                    </>
                  );
                }
              }}
            />
            {isTablet && (
              <TransportData
                origin={origin}
                reDelivery={reDelivery}
                destination={destination}
                shippingCompany={shippingCompany}
                isTablet={isTablet}
              />
            )}
          </S.HeaderWrapper>
          <S.TrackingWrapper>
            {isMobile && (
              <Fragment>
                <S.GradientBlock first />
                <S.GradientBlock last />
              </Fragment>
            )}
            <S.TrackingRow isMobile={isMobile}>
              {isDesktop && (
                <S.TransportDataContainer>
                  <TransportData
                    origin={origin}
                    reDelivery={reDelivery}
                    destination={destination}
                    shippingCompany={shippingCompany}
                    isDesktop={isDesktop}
                  />
                  {/* <>{this._renderTrackingManager()}</> */}
                </S.TransportDataContainer>
              )}
              <S.TimelineWrapper>
                <S.StatusContainer isDesktop={isDesktop}>
                  <StatusFlow
                    wms={wms.progress}
                    tms={tms.progress}
                    truckTracker={tms.truckTracker}
                    isMobile={isMobile}
                    nfData={nfData}
                    hasPosition={hasPosition}
                    finishedDate={tms.finishedDate}
                    stepInvoice={stepInvoice}
                    hasReceipts={tms.hasReceipts}
                    openReceipt={openReceipt}
                    isAgroDivision={isAgro}
                    transferTripsCount={tms.transferTripsCount}
                  />
                </S.StatusContainer>
                <TrackingFooter
                  isDesktop={isDesktop}
                  isMobile={isMobile}
                  nfData={nfData}
                  hasOccurence={hasOccurence}
                  openOccurence={openOccurence}
                />              
              </S.TimelineWrapper>
            </S.TrackingRow>
          </S.TrackingWrapper>
        </S.TrackingItemContainer>

        {/* (12-2025-Tracking-Cors) */}
        {/* <ConfirmationModal
          onDetails={onClick}
          trackingStatus={this.state.trackingManagerActive}
          open={this.state.showConfirmationModal}
          onClose={this._handleShowConfirmationModal}
          onConfirm={() => this._handleTrackingManager(cnpjDest)}
        /> */}

        <RegisterModal
          open={this.state.showRegisterModal}
          handleCreateNewUser={this._handleShowRegisterModal}
          onClose={this._handleCloseShowRegisterModal}
          dispatch={this.props.dispatch}
          companiesList={customerCompaniesList}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    roles: state.auth.roles,
    currentCompanyDivisions: state.auth.activeCompanyDivisions
      ? state.auth.activeCompanyDivisions.split(',')
      : [],
    customerCompaniesList: state.trackingManager.customerCompanyList.data,
  };
}

export default connect(mapStateToProps)(NewTrackingNFItem);
